import { VoiceCrossFrameWrapper } from '@services/voice/VoiceCrossFrameWrapper';

const voiceCrossFrameWrapper = new VoiceCrossFrameWrapper();

/**
 * Client for the SpeechSynthesisService in base tool. {@see SpeechSynthesisService} in base tool
 * for more documentation on how this client can be used and how it can fail.
 */
export class SpeechSynthesisClient {
    /**
     * Warms up the speech synthesis client so that the first call to speak doesn't get impacted
     * by this latency.
     *
     * The caller of this public static is encouraged to catch any exceptions and ignore them since it
     * could be a transient issue and a call to speak might still work if the transient issue has
     * been resolved (with some added latency).
     *
     * @return {Promise} Resolves when warmup finishes successfully and rejects when it doesn't.
     */
    public static warmup() {
        return SpeechSynthesisClient.makeCrossFrameCall('warmup');
    }

    /**
     * Calls speak with the provided config. config can either be an object with the "text" key
     * or text (as a shorthand).
     *
     * @param {object|string} The config object to send.
     * @return {Promise} The promise resolves when the audio for the synthesis is done playing and
     *  rejects if there's an error.
     */
    public static speak(config) {
        return SpeechSynthesisClient.makeCrossFrameCall('speak', config);
    }

    /**
     * Calls repeat so that the last sentence that was spoken is repeated.
     * @return {Promise} Resolves when the audio is done playing and rejects if there's
     *  an error.
     */
    public static repeat() {
        return SpeechSynthesisClient.makeCrossFrameCall('repeat');
    }

    /**
     * Makes the cross frame call to base tool.
     */
    private static makeCrossFrameCall(action, parameters?) {
        return voiceCrossFrameWrapper.call('speechSynthesisListener', action, parameters);
    }
}
